import styled, { css, keyframes } from "styled-components";
import { slideInVertical } from "../../../animations/slideIn";
import { animationDuration, pageGutterSpace, zIndex } from "../../../settings";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import ContainerOrg from "../ContainerOrg";
import WrapOrg from "../WrapOrg";
var gutterExceptMobileSpace = pageGutterSpace;
export var backgroundColor = "background";
var overlayAnimation = function overlayAnimation(theme) {
  return keyframes(["from{background-color:transparent;}to{background-color:", ";}"], getColor(theme, backgroundColor));
};
export var Overlay = styled.div.withConfig({
  componentId: "sc-1zisov-0"
})(function (_ref) {
  var theme = _ref.theme;
  return css(["display:flex;position:fixed;z-index:", ";top:0;right:0;bottom:0;left:0;align-items:flex-start;justify-content:center;width:100%;height:100vh;padding:", ";overflow-y:auto;animation:", " ", "s forwards;"], zIndex.ModalOrg, space(gutterExceptMobileSpace), overlayAnimation(theme), animationDuration.slow / 1000);
});
export var StyledContainerOrg = styled(ContainerOrg).withConfig({
  componentId: "sc-1zisov-1"
})(["display:flex;flex-direction:column;padding:0;animation:", " ", "s forwards;"], slideInVertical(), animationDuration.slow / 1000);
export var StyledWrapOrg = styled(WrapOrg).withConfig({
  componentId: "sc-1zisov-2"
})(["height:100%;"]);